<template>
  <div>
    <div v-if="hasJob" class="d-flex CARD">
      <div
          class="APPOINTMENT-LIST-ITEM flex-1-1 BORDER-LEFT">
        <div class="d-flex flex-1-1 fd-column p-l-2 p-y-1" >
          <transition v-if="$device.isMobile" name="FADE" mode="out-in">
            <div class="text-md">
              <router-link
                  :to="{
                    name: 'dashboard::pro::jobs',
                    params: {
                      jobId: isSearchStatusAlias ? undefined : jobId,
                      jobsStatusAlias,
                    },
                    query: {
                      [$options.JOBS_QUERY_PARAMS.IDS]: isSearchStatusAlias ? [jobId] : undefined,
                    },
              }">
                <span class="text-bold text-underline h6 c-gray80">
                  {{ job.service_name }} - {{appointmentPurpose}}
                </span>
              </router-link>
              <div class="d-flex ">
                <div class="d-flex fd-column m-r-1">
                  <span class="text-bold">Name</span>
                  <span class="m-b-1">
                    {{job.location.first_name | fullName(job.location.last_name)}}
                  </span>
                  <span class="text-bold">Location</span>
                  <div v-if="appointment.address" class="d-flex fd-column">
                    <a
                        :href="mapsUrl"
                        class="link x-white-space-pre-wrap"
                        rel="noopener noreferrer"
                        target="_blank">{{appointment.address | location(multiline=true)}}</a>
                    <p
                        class="text-md text-underline c-gray60 p-b-1"
                    >
                      {{ appointment.address.address_line_2 }}
                    </p>
                  </div>
                  <span v-else class="m-b-1">
                    {{appointment.address || job.location | location(multiline=true)}}
                  </span>
                  <div class="d-flex">
                    <div class="d-flex fd-column m-r-2">
                      <span class="text-bold">Starts</span>
                      <span class="text-sm"> {{ formattedDate(appointment.start_dtm) }}</span>
                    </div>
                    <div class="d-flex fd-column">
                      <span class="text-bold">Ends</span>
                      <span class="text-sm"> {{ formattedDate(appointment.end_dtm) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <transition v-else name="FADE" mode="out-in">
            <div class="text-md">
              <router-link
                  :to="{
                    name: 'dashboard::pro::jobs',
                    params: {
                      jobId: isSearchStatusAlias ? undefined : jobId,
                      jobsStatusAlias,
                    },
                    query: {
                      [$options.JOBS_QUERY_PARAMS.IDS]: isSearchStatusAlias ? [jobId] : undefined,
                    },
                  }"
              >
                <span class="text-bold text-underline h6 c-gray80 ">
                  {{ job.service_name }} - {{appointmentPurpose}}
                </span>
              </router-link>
              <div class="d-flex">
                <div class="d-flex fd-column jc-between ITEM-SECTION">
                  <div class="d-flex fd-column">
                    <span class="text-bold">Name</span>
                    <span class="p-b-1">
                      {{job.location.first_name | fullName(job.location.last_name)}}
                    </span>
                  </div>
                  <div class="d-flex fd-column">
                    <span class="text-bold">Starts</span>
                    <span> {{ formattedDate(appointment.start_dtm) }}</span>
                  </div>
                </div>
                <div class="d-flex fd-column jc-between ITEM-SECTION">
                  <div class="d-flex fd-column">
                    <span class="text-bold">Location</span>
                    <div
                        v-if="appointment.address"
                        class="d-flex text-underline fd-column"
                    >
                      <a
                          :href="mapsUrl"
                          class="x-white-space-pre-wrap"
                          rel="noopener noreferrer"
                          target="_blank">{{appointment.address | location(multiline=true)}}</a>
                      <p
                          class="text-md text-underline p-b-1"
                      >
                        {{ appointment.address.address_line_2 }}
                      </p>
                    </div>
                    <span v-else>
                      {{appointment.address || job.location | location(multiline=true)}}
                    </span>
                  </div>
                  <div class="d-flex fd-column">
                    <span class="text-bold">Ends</span>
                    <span> {{ formattedDate(appointment.end_dtm) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="flex-0-0 m-x-0:mo">
        <vk-listbox
            display-text="..."
            class="OPTIONS"
            menuClass="MENU"
            value=""
            @input="handleSelection">
          <vk-listbox-option
              v-for="(option, index) in options"
              class="OPTION bd-x-gray50 text-bold"
              :class="{
                'bd-t-gray50':index === 0,
                'c-depot':index ===options.length -1
              } "
              :key="index + option"
              :value="option">
            {{ option }}
          </vk-listbox-option>
        </vk-listbox>
      </div>
    </div>
  </div>
</template>

<script>
import { isToday, isTomorrow, format } from 'date-fns';
import fullName from '@/filters/full-name';
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';
import subtask from '@/mixins/job/subtask';
import appointment from '@/mixins/appointment';
import { PURPOSES_MAP } from '@/constants/appointments';
import location from '@/filters/location';


export default {
  isToday,
  isTomorrow,
  name: 'appointment-list-item',
  mixins: [
    jobParams,
    job,
    subtask,
    appointment,
  ],
  props: {
    id: [String, Number],
  },
  data () {
    return {
      options: ['Edit', 'Export', 'Delete'],
    };
  },
  computed: {
    // Used by appointment mixin.
    appointmentId () {
      return this.id;
    },
    // Used by job mixin.
    jobId () {
      return this.appointment.order_hash;
    },
    // Used by subtask mixin.
    subtaskId () {
      return this.job.subtask;
    },
    jobsStatusAlias () {
      let result = this.$options.JOBS_STATUS_ALIASES.search.key;

      if (this.match) {
        const allStatusAliases = Object.values(
          this.$options.JOBS_STATUS_ALIASES
        );
        const jobsStatusAlias = allStatusAliases.find(alias =>
          alias.statuses.includes(this.match.status)
        );
        if (jobsStatusAlias) {
          result = jobsStatusAlias.key;
        }
      }

      return result;
    },
    appointmentPurpose () {
      if (this.appointment.purpose !== 'other') {
        return PURPOSES_MAP[this.appointment.purpose].short;
      }
      return this.appointment.purposeDescription || PURPOSES_MAP.other.short;
    },
    hasJob () {
      return !!this.job;
    },
    mapsLocation () {
      return location(this.appointment.address).replace(/\s/g, '+');
    },
    mapsUrl () {
      return `https://www.google.com/maps/search/?api=1&query=${this.mapsLocation}`;
    },
  },
  methods: {
    handleSelection (selectedOption) {
      switch (selectedOption) {
        case 'Delete':
          this.$events.$emit(this.$events.APPOINTMENT_DOTS_DELETE_CLICK);
          this.deleteAppointment();
          break;
        case 'Export':
          this.$events.$emit(this.$events.APPOINTMENT_DOTS_EXPORT_CLICK);
          this.onAppointmentsExport();
          break;
        default:
          this.$events.$emit(this.$events.APPOINTMENT_DOTS_EDIT_CLICK);
          this.$router.push({
            name: 'dashboard::pro::jobs',
            params: {
              jobId: this.isSearchStatusAlias ? undefined : this.jobId,
              jobsStatusAlias: this.jobsStatusAlias,
            },
            query: {
              [this.$options.JOBS_QUERY_PARAMS.IDS]: this.isSearchStatusAlias
                ? [this.jobId] : undefined,
            },
          });
      }
    },
    async onAppointmentsExport () {
      const { first_name, last_name } = this.job.location;
      const customersFullName = fullName(first_name, last_name);
      const { data, headers } = await this.exportAppointments({
        appointmentId: this.appointment.appointment_id,
        serviceProviderId: this.appointment.service_provider_id,
      });
      const blob = new Blob([data], { type: headers['Content-Type'] });
      const link = global.document.createElement('a');
      link.href = global.window.URL.createObjectURL(blob);
      link.download = `${customersFullName} - ${this.job.service_name}.ics`.replace(/\s/g, '_');

      link.click();
    },
    deleteAppointment () {
      this.$emit('onDelete', {
        appointment: this.appointment,
        jobId: this.job.id,
      });
    },
    formattedDate (date) {
      return format(new Date(date), 'MMM dd, yyyy | h:mmaaa');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  @import "~@/views/Dashboard/constants";
  @import "~@/views/Dashboard/tools";

  .APPOINTMENT-LIST-ITEM {
    @include hover(text-decoration, none, none);
    @include desktop-hover(background-color, transparent, $color-gray20);
    @include pseudo(visited, color, $color-gray80, $color-gray80);
    display: flex;
    flex: 0 0 auto;
    padding-bottom: 1* $unit;
    margin: 0.5 * $unit 0;
    background-color: white;
    will-change: background-color;
    transition: background-color $transition-half-duration;
    overflow-wrap: break-word;
    border-color: #F96302;
    @include mobile-only () {
      width:90vw;
    }
  }
  .CARD {
    flex: 1 1 auto;
    justify-content: space-between;
    border-bottom: 1px solid $color-gray30;
  }
  .TIME {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    width: 14.25 * $unit;
    padding-right: .25* $unit;
    text-align: left;
  }
  .OPTIONS {
    @include text-medium;

    /deep/ .input {
      height: 100px;
      width: 50px;
      padding: 0;
      border: none;
      font-weight: 700;
      font-size: 34px;
      color: $color-depot;
      font-family: serif;
      align-items: start;
      margin-left: $unit;
      .VK-LISTBOX-TEXT {
        padding-right: $unit;
      }
      .CHEVRON {
        color: transparent;
      }
    }
    /deep/ .MENU {
      top: 3*$unit;
      right: 0;
      height: auto;
      width: 100px;
      padding: $unit 0;
      border: none;
      overflow: auto;
      background-color: transparent;
    }
  }
  .OPTION {
    background-color: white;
    border-bottom: solid 1px $color-gray50;
    @include hover(transform, none, none);
    transition: none;

  }
  .VK-LISTBOX-OPTION.SELECTED {
    background-color: white;
    color: $color-gray70
  }
  .DATE-HEADING {
    align-items: left;
    transition: all $transition-duration;
  }
  .VK-LISTBOX-TEXT {
        font-size:large;
        color: $color-depot;
      }
  .BUTTON{
    min-height: $appointment-list-item-min-height;
  }
  .BORDER-LEFT {
    border-left:6px solid $color-depot;
  }
   a:visited, a:hover, a:active {
    color:blue;
    text-decoration: underline;
  }
  .ITEM-SECTION {
    max-width: 180px;
    flex: 1 1 auto;
  }
</style>
